const API_URI = 'https://api.honda-dream-japan.co.jp'

const Util = {
  // API URL
  API: {
    products: `${API_URI}/products`,
    productNames: `${API_URI}/product-names`,
  },
  // 消費税率
  TAX: 1.1,
  // バイク種別 ID
  TYPE_ID: {
    new: 1,
    used: 2,
    test: 3,
  },
  // バイク種別 ラベル
  TYPE_LABEL: {
    new: '新車',
    used: '中古車',
    test: '試乗車',
  },
  // 検索表示数
  SEARCH_LIMIT: 20,
  // 排気量
  DISPLACEMENT: [
    { value: '', label: '排気量を選択してください', from: 0, to: 0 },
    { value: '50', label: '50cc以下', from: 0, to: 50 },
    { value: '51-125', label: '51cc～125cc', from: 51, to: 125 },
    { value: '126-250', label: '126cc～250cc', from: 126, to: 250 },
    { value: '251-400', label: '251cc～400cc', from: 251, to: 400 },
    { value: '401-750', label: '401cc～750cc', from: 401, to: 750 },
    { value: '751-1000', label: '751cc～1000cc', from: 751, to: 1000 },
    { value: '1001', label: '1001cc以上', from: 1001, to: 99999 },
  ],
  // 走行距離
  MILEAGE: [
    { value: '', label: '走行距離を選択してください', from: 0, to: 0 },
    { value: '1000', label: '1000km以下', from: 0, to: 1000 },
    { value: '1000-5000', label: '1000～5000km', from: 1000, to: 5000 },
    { value: '5000-10000', label: '5000～10000km', from: 5000, to: 10000 },
    { value: '10000-15000', label: '10000～15000km', from: 10000, to: 15000 },
    { value: '15000', label: '15000km以上', from: 15000, to: 99999 },
  ],
  // 店舗マスタ
  DEALER: {
    area: [
      {
        name: '東北エリア',
        shops: [
          { shop_id: 275, id: 3, name: 'ホンダドリーム 盛岡' },
          { shop_id: 283, id: 2, name: 'ホンダドリーム 仙台泉' },
          { shop_id: 288, id: 4, name: 'ホンダドリーム 宮城岩沼' },
          { shop_id: 308, id: 1, name: 'ホンダドリーム 郡山' },
        ],
      },
      {
        name: '関東エリア',
        shops: [
          { shop_id: 312, id: 65, name: 'ホンダドリーム 水戸北' },
          { shop_id: 244, id: 67, name: 'ホンダドリーム ふかや花園' },
          { shop_id: 338, id: 56, name: 'ホンダドリーム 鴻巣' },
          { shop_id: 347, id: 57, name: 'ホンダドリーム 所沢' },
          { shop_id: 356, id: 58, name: 'ホンダドリーム 大宮' },
          { shop_id: 361, id: 59, name: 'ホンダドリーム 狭山' },
          { shop_id: 317, id: 60, name: 'ホンダドリーム 船橋' },
          { shop_id: 321, id: 62, name: 'ホンダドリーム 松戸' },
          { shop_id: 366, id: 61, name: 'ホンダドリーム 東浦和' },
          { shop_id: 330, id: 63, name: 'ホンダドリーム 蘇我' },
          { shop_id: 370, id: 64, name: 'ホンダドリーム 草加' },
          { shop_id: 377, id: 66, name: 'ホンダドリーム 新座' },
          { shop_id: 10, id: 29, name: 'ホンダドリーム 世田谷' },
          { shop_id: 382, id: 30, name: 'ホンダドリーム 西東京' },
          { shop_id: 391, id: 34, name: 'ホンダドリーム 練馬' },
          { shop_id: 419, id: 35, name: 'ホンダドリーム 板橋' },
          { shop_id: 432, id: 36, name: 'ホンダドリーム 葛飾' },
          { shop_id: 439, id: 37, name: 'ホンダドリーム 大田' },
          { shop_id: 448, id: 40, name: 'ホンダドリーム 立川' },
          { shop_id: 461, id: 31, name: 'ホンダドリーム 磯子' },
          { shop_id: 466, id: 32, name: 'ホンダドリーム 横浜都筑' },
          { shop_id: 477, id: 33, name: 'ホンダドリーム 横浜旭' },
          { shop_id: 496, id: 38, name: 'ホンダドリーム 川崎宮前' },
          { shop_id: 487, id: 39, name: 'ホンダドリーム 横浜緑' },
        ],
      },
      {
        name: '中部エリア',
        shops: [
          { shop_id: 503, id: 90, name: 'ホンダドリーム 名古屋中央' },
          { shop_id: 515, id: 91, name: 'ホンダドリーム 名古屋南' },
          { shop_id: 520, id: 92, name: 'ホンダドリーム 小牧' },
          { shop_id: 529, id: 93, name: 'ホンダドリーム 名古屋東' },
          { shop_id: 540, id: 94, name: 'ホンダドリーム 一宮' },
          { shop_id: 677, id: 95, name: 'ホンダドリーム 豊橋' },
          { shop_id: 545, id: 96, name: 'ホンダドリーム 名古屋上小田井' },
          { shop_id: 555, id: 97, name: 'ホンダドリーム 岐阜' },
        ],
      },
      {
        name: '近畿エリア',
        shops: [
          { shop_id: 560, id: 124, name: 'ホンダドリーム 奈良' },
          { shop_id: 567, id: 125, name: 'ホンダドリーム 堺' },
          { shop_id: 571, id: 126, name: 'ホンダドリーム 神戸灘' },
          { shop_id: 575, id: 127, name: 'ホンダドリーム 箕面' },
          { shop_id: 579, id: 128, name: 'ホンダドリーム 藤井寺' },
          { shop_id: 583, id: 129, name: 'ホンダドリーム 京都伏見' },
          { shop_id: 587, id: 130, name: 'ホンダドリーム 尼崎' },
          { shop_id: 593, id: 131, name: 'ホンダドリーム 東淀川' },
          { shop_id: 598, id: 132, name: 'ホンダドリーム 豊中' },
          { shop_id: 602, id: 133, name: 'ホンダドリーム 京都右京' },
          { shop_id: 606, id: 134, name: 'ホンダドリーム 京都北山' },
          { shop_id: 610, id: 135, name: 'ホンダドリーム 姫路' },
          { shop_id: 3480, id: 175, name: 'ホンダドリーム 西宮甲子園' },
        ],
      },
      {
        name: '中国・四国エリア',
        shops: [
          { shop_id: 614, id: 138, name: 'ホンダドリーム 広島' },
          { shop_id: 618, id: 139, name: 'ホンダドリーム 福山' },
          { shop_id: 622, id: 140, name: 'ホンダドリーム 高松' },
          { shop_id: 626, id: 141, name: 'ホンダドリーム 岡山' },
          { shop_id: 630, id: 142, name: 'ホンダドリーム 高知' },
          { shop_id: 634, id: 143, name: 'ホンダドリーム 徳島' },
        ],
      },
      {
        name: '九州エリア',
        shops: [
          { shop_id: 638, id: 154, name: 'ホンダドリーム 熊本' },
          { shop_id: 652, id: 155, name: 'ホンダドリーム 博多' },
          { shop_id: 659, id: 156, name: 'ホンダドリーム 福岡東' },
          { shop_id: 663, id: 157, name: 'ホンダドリーム 久留米' },
          { shop_id: 667, id: 158, name: 'ホンダドリーム 福岡春日' },
          { shop_id: 672, id: 159, name: 'ホンダドリーム 福岡西' },
        ],
      },
    ],
  },
  // 予算選択肢
  PRICE_RANGE: [
    50000, 100000, 150000, 200000, 150000, 300000, 350000, 400000, 450000, 500000, 550000, 600000,
    650000, 700000, 750000, 800000, 850000, 900000, 950000, 1000000, 1100000, 1200000, 1300000,
    1400000, 1500000, 1600000, 1700000, 1800000, 1900000, 2000000, 2200000, 2400000, 2600000,
    2800000, 3000000, 3200000, 3400000, 3600000, 3800000, 4000000,
  ],
  // 新着表示期間 (日数)
  NEW_ARRIVAL_PERIOD: 10,
}

export { Util }
